var ua = window.navigator.userAgent;
var wechattype = false;
//判断是不是微信
if (ua.indexOf("MicroMessenger") > 0) {
	wechattype = true;
}

//判断是不是支付宝
if (ua.indexOf("AlipayClient") > 0) {
	wechattype = false;
}

export default wechattype